import { useState, useEffect } from 'react';
import store from 'store';

export const AppCache = {
    get: (key) => store.get(key),
    set: (key, value) => store.set(key, value),
    remove: (key) => store.remove(key),
};

export function useAppCache(key, defaultValue?: any) {
    const [state, setState] = useState(AppCache.get(key) ?? defaultValue);

    return [
        state,
        (value) => {
            AppCache.set(key, value);
            setState(value);
        },
    ];
}

export function useAppCacheAutoSync(key, value) {
    useEffect(() => {
        AppCache.set(key, value);
    }, [value]);
}
